import { useUrlParamsValueToString } from "@bsm/component";

export const useInvoiceViewerMenu = () => {
    const urlParams = useUrlParamsValueToString();

    return [
        {
            ke: "signatories",
            label: "Signatories",
            link: `signatories?${urlParams}`,
        },
        {
            ke: "email",
            label: "Email",
            link: `email?${urlParams}`,
        },
    ];
};
